import { Box, Grid, Typography, Button } from '@mui/material';

export default function CtaEcomm() {
  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 4, md: 6 },
        position: 'relative',
        backgroundPosition: 'center',
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, sm: 4, md: 6 }}
        sx={{
          position: 'relative',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: { xs: 'center', md: 'left' },
            mt: { xs: 0, md: 0 },
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
              fontWeight: 'bold',
              mb: 2,
            }}
          >
            Make payments easy, simplify your finances
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
              mb: 4,
            }}
          >
            A new way to make the payments easy, reliable, and secure. You can
            manage all your transactions from your mobile phone.
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              width: { xs: '100%', sm: '200px' },
              alignSelf: { xs: 'center', md: 'flex-start' },
              mb: 2,
            }}
          >
            Get Started
          </Button>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            By clicking "Sign up now", you are accepting our{' '}
            <Typography
              component="a"
              href="/terms"
              sx={{ color: 'primary.main', textDecoration: 'none' }}
            >
              Terms and Conditions
            </Typography>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            height: 'auto',
            mt: { xs: 4, md: 0 },
          }}
        >
          <img
            src={'/ecomm-hero.svg'}
            alt="Banking interface illustration"
            style={{
              width: '100%',
              maxWidth: '420px',
              objectFit: 'contain',
              margin: 0,
              padding: 0,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
